import * as tslib_1 from "tslib";
import { EditorType_$type } from "./EditorType";
import { IgrColumn } from "./igr-column";
import { TextColumn } from "./TextColumn";
import { ensureEnum } from "igniteui-react-core";
/**
 * Represents a Text grid column, used to allow the developer to display a formatted text in a cell.
*/
var IgrTextColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrTextColumn, _super);
    function IgrTextColumn(props) {
        return _super.call(this, props) || this;
    }
    IgrTextColumn.prototype.createImplementation = function () {
        return new TextColumn();
    };
    Object.defineProperty(IgrTextColumn.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrTextColumn.prototype, "editorType", {
        /**
         * Gets or sets the editor type used for editing cells in this column.
        */
        get: function () {
            return this.i.j3;
        },
        set: function (v) {
            this.i.j3 = ensureEnum(EditorType_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrTextColumn.prototype, "editorDataSource", {
        /**
         * Gets or sets the ComboBox data source.
        */
        get: function () {
            return this.i.j4;
        },
        set: function (v) {
            this.i.j4 = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrTextColumn.prototype, "editorTextField", {
        /**
         * Gets or sets the ComboBox text field.
        */
        get: function () {
            return this.i.j6;
        },
        set: function (v) {
            this.i.j6 = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrTextColumn.prototype, "editorValueField", {
        /**
         * Gets or sets the ComboBox value field.
        */
        get: function () {
            return this.i.j2;
        },
        set: function (v) {
            this.i.j2 = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrTextColumn;
}(IgrColumn));
export { IgrTextColumn };
//# sourceMappingURL=igr-text-column.js.map
